import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { Mail, KeyRound, Inbox, Loader2 } from "lucide-react";

const LEGACY_RESET_RE = /(\/reset-password\?token=[A-Za-z0-9_-]+)/;

export const MailOutbox = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [minting, setMinting] = useState(null);

  useEffect(() => {
    api.get("/admin/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const openResetLink = async (n) => {
    setMinting(n.id);
    try {
      const { data } = await api.post("/admin/reset-link", { email: n.email });
      navigate(data.reset_link);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setMinting(null);
    }
  };

  return (
    <div className="space-y-4" data-testid="mail-outbox">
      <div className="bg-white rounded-lg border border-[#e2ebe4] p-5">
        <h2 className="heading-upper text-sm tracking-widest text-[#144733] flex items-center gap-2">
          <Inbox className="w-4 h-4 text-[#009900]" /> Email outbox (mocked)
        </h2>
        <p className="text-xs text-[#57685e] mt-1">
          Email sending is MOCKED in this demo — every email the platform would send lands here instead
          (booking confirmations, password resets, complaint updates). Reset tokens are never stored:
          "Generate reset link" mints a fresh secure link on demand, visible only to you.
        </p>
      </div>
      <div className="bg-white rounded-lg border border-[#e2ebe4] divide-y divide-[#f1f3f1]" data-testid="outbox-list">
        {items === null && <p className="p-6 text-xs text-[#8a978f] text-center">Loading…</p>}
        {items !== null && items.length === 0 && <p className="p-6 text-xs text-[#8a978f] text-center">No emails logged yet.</p>}
        {(items || []).map((n) => {
          const isReset = n.kind === "password_reset" || LEGACY_RESET_RE.test(n.body || "");
          return (
            <div key={n.id} className="p-4" data-testid={`outbox-item-${n.id}`}>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <div className="flex items-center gap-2 min-w-0">
                  <Mail className="w-4 h-4 text-[#009900] shrink-0" />
                  <span className="text-sm font-bold text-[#0F1E17] truncate">{n.subject}</span>
                </div>
                <span className="text-[10px] text-[#8a978f]">{dayjs(n.created_at).format("DD MMM YYYY, HH:mm")}</span>
              </div>
              <p className="text-[11px] text-[#57685e] mt-1">To: {n.email}</p>
              <p className="text-xs text-[#41504a] mt-2 leading-relaxed break-words">{n.body}</p>
              {isReset && (
                <button type="button" onClick={() => openResetLink(n)} disabled={minting === n.id}
                  className="btn-cta rounded px-4 py-2 text-[11px] inline-flex items-center gap-1.5 mt-3 disabled:opacity-60"
                  data-testid={`outbox-reset-btn-${n.id}`}>
                  {minting === n.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <KeyRound className="w-3.5 h-3.5" />}
                  Generate reset link
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
